<section *ngIf="!tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'umustlogin' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/login">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'login' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'true'">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'noAuth' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'false'">
    <div class="rbt-dashboard-area rbt-section-gapBottom" style="margin: 50px 0;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="rbt-dashboard-content-wrapper">
                        <div class="tutor-bg-photo bg_image bg_image--22 height-350"></div>
                        <div class="rbt-tutor-information">
                            <div class="rbt-tutor-information-left">
                                <div class="thumbnail rbt-avatars size-lg">
                                    <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.student.img" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="Instructor">
                                </div>
                                <div class="tutor-content">
                                    <h5 class="title">{{this.userFullName}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row g-5">
                        <div class="col-lg-3">
                            <div class="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                                <div class="inner">
                                    <div class="content-item-content">

                                        <div class="rbt-default-sidebar-wrapper">
                                            <div class="section-title mb--20">
                                                <h6 class="rbt-title-style-2">{{'Welcome' | translate}} {{this.userFullName}}</h6>
                                            </div>
                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewStudProfile(this.studentId)"><i class="feather-user"></i><span>{{'View Profile' | translate}}</span></a></li>
                                                    <li><a (click)="viewStudCourses(this.studentId)"><i class="feather-monitor"></i><span>{{'Courses' | translate}}</span></a></li>
                                                    <!-- <li><a (click)="viewWishlist(this.studentId)"><i class="feather-heart"></i><span>{{'fav' | translate}}</span></a></li> -->
                                                </ul>
                                            </nav>

                                            <div class="section-title mt--40 mb--20">
                                                <h6 class="rbt-title-style-2">{{'UserSettings' | translate}}</h6>
                                            </div>

                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewStudSettings(this.studentId)"><i class="feather-settings"></i><span>{{'Settings' | translate}}</span></a></li>
                                                   
                                                </ul>
                                            </nav>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-9">
                            <div class="rbt-dashboard-content bg-color-white rbt-shadow-box">
                                <div class="content">

                                    <div class="section-title">
                                        <h4 class="rbt-title-style-3">{{'Settings' | translate}}</h4>
                                    </div>

                                    <div class="advance-tab-button mb--30">
                                        <ul class="nav nav-tabs tab-button-style-2 justify-content-start" id="settinsTab-4" role="tablist">
                                            <li role="presentation">
                                                <a href="#" class="tab-button active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" role="tab" aria-controls="profile" aria-selected="true">
                                                    <span class="title">{{'View Profile' | translate}}</span>
                                                </a>
                                            </li>
                                            <li role="presentation">
                                                <a href="#" class="tab-button" id="password-tab" data-bs-toggle="tab" data-bs-target="#password" role="tab" aria-controls="password" aria-selected="false">
                                                    <span class="title">{{'Password' | translate}}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="tab-content">
                                        <div class="tab-pane fade active show" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                            <div class="rbt-dashboard-content-wrapper">
                                                <div class="tutor-bg-photo bg_image bg_image--22 height-245"></div>
                                                <div class="rbt-tutor-information">
                                                    <div class="rbt-tutor-information-left">
                                                        <div class="thumbnail rbt-avatars size-lg position-relative">
                                                            <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.student.img" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="Instructor">
                                                            <div class="rbt-edit-photo-inner">
                                                                <button class="rbt-edit-photo" title="Upload Photo">
                                                                    <label style="cursor: pointer;" for="profilePic"><i class="feather-camera"></i></label>
                                                                    <input style="opacity: 0;display: none;cursor: pointer;" name="profilePic" id="profilePic" type="file" class="inputfile" accept="image/x-png,image/gif,image/jpeg"
                                                                    (change)="profilePic($event)" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="rbt-tutor-information-right">
                                                        <!-- <div class="tutor-btn">
                                                            <a class="rbt-btn btn-sm btn-border color-white radius-round-10">{{'Edit Cover Photo' | translate}}</a>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Start Profile Row  -->
                                            <form action="#" class="rbt-profile-row rbt-default-form row row--15">
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div class="rbt-form-group">
                                                        <label for="firstname">{{'First Name' | translate}}</label>
                                                        <input name="firstname" id="firstname" type="text" [(ngModel)]="student.name" ngModel #firstname="ngModel">
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div class="rbt-form-group">
                                                        <label for="lastname">{{'Last Name' | translate}}</label>
                                                        <input name="lastname" id="lastname" type="text" [(ngModel)]="student.surname" ngModel #lastname="ngModel">
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 25px;">
                                                    <div class="rbt-form-group">
                                                        <label for="username">{{'Email' | translate}}</label>
                                                        <input name="Email" id="Email" type="email" [(ngModel)]="student.emailAddress" ngModel #Email="ngModel" [email]="true">
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="margin-top: 25px;">
                                                    <div class="rbt-form-group">
                                                        <label for="phonenumber">{{'Phone Number' | translate}}</label>
                                                        <input name="mobile" id="mobile" type="text" [(ngModel)]="student.mobile" ngModel #mobile="ngModel">
                                                    </div>
                                                </div>
                                                <div class="col-12 mt--20">
                                                    <div class="rbt-form-group">
                                                        <button class="rbt-btn btn-gradient" [class.spinner]="loading"  (click)="saveStudent()" [disabled]="loading">{{'Update' | translate}}</button>
                                                    </div>
                                                </div>
                                            </form>
                                            <!-- End Profile Row  -->
                                        </div>

                                        <div class="tab-pane fade" id="password" role="tabpanel" aria-labelledby="password-tab">
                                            <form #passForm="ngForm" id="passForm" novalidate class="rbt-profile-row rbt-default-form row row--15">
                                                <div class="col-12">
                                                    <div class="rbt-form-group passForm">
                                                        <input id="currentPassword" name="currentPassword"  type="password" placeholder="{{'currentPassword' | translate}}" #input1 [(ngModel)]="changePassword.currentPassword" required ngModel #currentPassword="ngModel">
                                                        <div class="rev_pass"><i class="feather-eye" style="position: absolute;cursor: pointer;" (click)="changeInput1(input1)"></i></div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="rbt-form-group passForm"> 
                                                        <input id="newPassword" type="password" name="newPassword" #input2 placeholder="{{'newPassword' | translate}}" [(ngModel)]="changePassword.newPassword" required ngModel #newPassword="ngModel">
                                                        <div class="rev_pass"><i class="feather-eye" style="position: absolute;cursor: pointer;" (click)="changeInput2(input2)"></i></div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="rbt-form-group passForm">
                                                        <input id="confirmNewPassword" name="confirmNewPassword"  type="password" #input3 placeholder="{{'confirmNewPassword' | translate}}" [(ngModel)]="changePassword.confirmNewPassword" required ngModel #confirmNewPassword="ngModel">
                                                        <div class="rev_pass"><i class="feather-eye" style="position: absolute;cursor: pointer;" (click)="changeInput3(input3)"></i></div>
                                                    </div>
                                                    <small class="d-block mt_dec--5" *ngIf="changePassword.confirmNewPassword != changePassword.newPassword"><i class="feather-info" style="margin-left: 5px;"></i> {{'NotTheSame' | translate}}</small>
                                                </div>
                                                <div class="col-12 mt--10">

                                                    <button class="rbt-btn btn-gradient" [class.spinner]="loading" (click)="changePass()" [disabled]="!(passForm.valid && passForm.dirty) || (changePassword.confirmNewPassword != changePassword.newPassword) || loading">{{'UpdatePassword' | translate}}</button>

                                                    <!-- <div class="rbt-form-group">
                                                        <button type="submit" class="rbt-btn btn-gradient hover-transform-none text-center" style="margin-left: 15px;" (click)="changePass()">
                                                            <span class="icon-reverse-wrapper">
                                                                <span class="btn-text">{{'UpdatePassword' | translate}}</span>
                                                            <span class="btn-icon"><i class="feather-arrow-right"></i></span>
                                                            <span class="btn-icon"><i class="feather-arrow-right"></i></span>
                                                            </span>
                                                        </button>
                                                    </div> -->
                                                </div>
                                            </form>
                                        </div>
                                    </div>





                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
